import { playerCountAtom } from "@/hooks/playerlist";
import { useAtomValue } from "jotai";
import { UsersIcon } from "lucide-react";


export default function PlayerlistSummary() {
    const playerCount = useAtomValue(playerCountAtom);
    const playerCountFormatted = playerCount.toLocaleString("en-US");

    return (
        <div className="w-full flex justify-between items-center">
            <div className="w-16 h-16 border border-edge bg-track rounded-tile flex items-center justify-center">
                <UsersIcon className="w-10 h-10 text-zinc-400 text-opacity-80 stroke-1" />
            </div>
            <div className="flex flex-col items-end">
                <div className="font-highlight text-display tabular leading-none scrim">{playerCountFormatted}</div>
                <div className="font-rad text-label uppercase tracking-[.12em] text-faint scrim">Players</div>
            </div>
        </div>
    );
}
